import React from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';

interface BaseForeignIdMapModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    candidates: any[];
    isLoading: boolean;
    error: Error | null;
    onSelect: (foreignId: string | number) => void;
}

export const BaseForeignIdMapModal: React.FC<BaseForeignIdMapModalProps> = ({
    open,
    onClose,
    title,
    candidates,
    isLoading,
    error,
    onSelect
}) => {
    return (
        <Modal show={open} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            
            <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                {isLoading && (
                    <p className="text-center">Loading candidates...</p>
                )}

                {error && (
                    <p className="text-danger">
                        Error: {error.message}
                    </p>
                )}

                {!isLoading && !error && candidates.length === 0 && (
                    <p className="text-center">
                        No available candidates found
                    </p>
                )}

                <ListGroup>
                    {candidates.map((candidate) => (
                        <ListGroup.Item
                            key={candidate.foreignId}
                            action
                            onClick={() => onSelect(candidate.foreignId)}
                            className="mb-2"
                        >
                            <div className="d-flex flex-column">
                                <strong>{candidate.name}</strong>
                                <small className="text-muted">
                                    ID: {candidate.foreignId}
                                    {candidate.matchScore > 0 && (
                                        <span className="ms-2">
                                            • Match Score: {Math.round(candidate.matchScore * 100)}%
                                        </span>
                                    )}
                                </small>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
}; 